import {useRef, useState} from "react";
import styled, {ThemeProvider} from "styled-components";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {profileState} from "../../app/reducers/profile-slice";
import {scheduleState} from "../../app/reducers/schedule-slice";
import theme from "../../style/theme";
import {Pathname} from "../../types/pathname";
import {Schedule} from "../../types/schedule/schedule";
import {timeFormat} from "../../utils/date/date-format";
import {LineNameCardPhoneDialog} from "../dialog/LineNameCardPhoneDialog";
import {UpdateScheduleAliasDialog} from "../dialog/UpdateScheduleAliasDialog";
import DeleteFillIcon from "../icons/DeleteFillIcon/DeleteFillIcon";
import PenLineIcon from "../icons/PenLineIcon/PenLineIcon";
import {useClickOutside} from "../../utils/click/handle-click";
import {EMPTY_LINE_NAME} from "../../utils/static/schedule-static";

interface Props {
    displaySchedule: Schedule;
}

export const LineNameCard: React.FC<Props> = (
    {
        displaySchedule
    }
) => {
    const dispatch = useAppDispatch();
    const {selectedSchedule} = useAppSelector(scheduleState);
    const {profile} = useAppSelector(profileState);
    const [updateScheduleAliasDialogOpen, setUpdateScheduleAliasDialogOpen] =
        useState(false);
    const isSelected = selectedSchedule?.id === displaySchedule.id;
    const lineChangeContainerRef = useRef<HTMLDivElement | null>(null);

    const isScheduleResetButtonVisible = () => {
        if (
            process.env.REACT_APP_MODE === "qa" ||
            process.env.REACT_APP_MODE === "dev"
        ) {
            return isSelected;
        }
        if (process.env.REACT_APP_MODE === "prod") {
            return isSelected && window.location.pathname === Pathname.ScheduleCheck;
        }
    };

    const handleClickUpdateScheduleAlias = (e: TouchEvent) => {
        if (selectedSchedule) {
            e.stopPropagation();
            setUpdateScheduleAliasDialogOpen(true);
        } else {
            setUpdateScheduleAliasDialogOpen(true);
        }
    };

    const handleClickResetButton = async (
        e: React.MouseEvent<HTMLButtonElement>
    ) => {
        // e.stopPropagation();
        // if (!selectedSchedule) {
        //   return;
        // }
        // if (window.confirm("해당 라인의 모든 상태가 ‘배송 전‘으로 초기화됩니다.")) {
        //   await cheatApi.resetSchedule({ scheduleId: displaySchedule.id });
        //   try {
        //     const response = await scheduleApi.getById({
        //       scheduleId: selectedScheduleId,
        //     });
        //     dispatch(
        //       updateScheduleInMapAsyncAction({ scheduleDto: response.data })
        //     );
        //   } catch (error) {
        //     console.log(error);
        //   }
        //   alert("초기화되었습니다.");
        //   return;
        // }
        // alert("취소되었습니다.");
    };

    useClickOutside(lineChangeContainerRef, () => setUpdateScheduleAliasDialogOpen(false));

    return (
        <ThemeProvider theme={theme}>
            <LineNameCardWrapper ref={lineChangeContainerRef}>
                <LineNameCardContainer
                    isSelected={isSelected}
                    onClick={() => {
                        // copyClipboardJson(displaySchedule);
                    }}
                >
                    {/* {isScheduleResetButtonVisible() && (
            <ResetButtonContainer>
              <ResetButton onClick={handleClickResetButton}>초기화</ResetButton>
            </ResetButtonContainer>
          )} */}

                    {isSelected && (
                        <CloseIconContainer>
                            <DeleteFillIcon width={20} height={20}/>
                        </CloseIconContainer>
                    )}

                    <WorkerContainer>
                        <NameLabel>
                            {displaySchedule.worker?.name
                                ? `${displaySchedule.worker?.name} 프로님`
                                : "프로님 배정전"}
                        </NameLabel>
                        <LineNameCardPhoneDialog
                            phone={displaySchedule.worker?.phone || ""}
                        />
                    </WorkerContainer>

                    <AliasContainer>
                        {displaySchedule.alias && displaySchedule.alias.trim() ? (
                            <AliasLabel>
                                {displaySchedule.alias.slice(0, 13)}
                                <CustomPenIcon
                                    className="pen-line-icon"
                                    onClick={handleClickUpdateScheduleAlias}
                                    updateScheduleAliasDialogOpen={updateScheduleAliasDialogOpen}
                                />
                            </AliasLabel>
                        ) : (
                            <AliasLabel className={"empty"}>{EMPTY_LINE_NAME}</AliasLabel>
                        )}
                        {updateScheduleAliasDialogOpen && (
                            <UpdateScheduleAliasDialog
                                displaySchedule={displaySchedule}
                                setUpdateScheduleAliasDialogOpen={
                                    setUpdateScheduleAliasDialogOpen
                                }
                            />
                        )}
                    </AliasContainer>

                    <TimeContainer>
                        <TimeLabel isNotEmpty={Boolean(displaySchedule.startedAt)}>
                            {timeFormat(displaySchedule.startedAt) || "00:00"} 시작
                        </TimeLabel>
                        <TimeLabel isNotEmpty={Boolean(displaySchedule.completedAt)}>
                            {timeFormat(displaySchedule.completedAt) || "00:00"} 종료
                        </TimeLabel>
                    </TimeContainer>
                </LineNameCardContainer>
            </LineNameCardWrapper>
        </ThemeProvider>
    );
};

const LineNameCardWrapper = styled.div`
  position: relative;
  padding: 8px 8px 7px 8px;
  border-bottom: 1px solid #ebeef3;
`;

interface LineNameCardContainerProps {
    isSelected: boolean;
}

const LineNameCardContainer = styled.div<LineNameCardContainerProps>`
  position: relative;
  width: 153px;
  height: 133px;
  display: flex;
  flex-direction: column;
  // align-items: center;
  // justify-content: center;
  box-sizing: border-box;
  padding: 15px 15px 0 15px;
  cursor: pointer;
  background: ${(props) =>
          props.isSelected
                  ? props.theme.palette.primitives["yellow50"]
                  : props.theme.palette.primitives.white};
  border-radius: 8px;
  border: 1px solid ${(props) =>
          props.isSelected
                  ? props.theme.palette.primitives["yellow400"]
                  : props.theme.palette.primitives.white};

  &:hover {
    background: ${(props) =>
            props.isSelected
                    ? props.theme.palette.primitives["yellow50"]
                    : props.theme.palette.primitives["gray50"]};
  }

  & .pen-line-icon {
    display: none;
  }

  &:hover .pen-line-icon {
    display: inline;
  }
`;

const WorkerContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 3px 0;
`;

const NameLabel = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 4px 0 0;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
    // color: ${(props) => props.theme.palette.primitives.gray800};
  color: #979da8;
`;

const AliasContainer = styled.div`
  position: relative;
  align-items: center;
  box-sizing: border-box;
  width: 121px;
  height: 42px;
  margin: 0 0 4px 0;
  padding: 0px;
`;

const AliasLabel = styled.p`
  width: 121px;
  padding: 0px;
  margin: 0px;
  font-weight: 700;
  font-size: 19px;
  line-height: 21px;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-break: break-all;

  & svg {
    display: none;
  }

  &:hover svg {
    display: block;
  }

  &.empty {
    font-size: 19px;
    font-weight: 500;
    color: ${theme.palette.primitives.gray300}
  }
`;

const TimeContainer = styled.div`
  width: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

interface TimeLabelProps {
    isNotEmpty: boolean;
}

const TimeLabel = styled.div<TimeLabelProps>`
  width: 120px;
  height: 16px;
  margin: 0 0 4px 0;
  font-size: 13px;
  line-height: 16px;
  font-weight: ${(props) => (props.isNotEmpty ? "700" : "400")};
  color: ${(props) => (props.isNotEmpty ? "#4D535C" : "#979DA8")};
`;

const CloseIconContainer = styled.div`
  width: 20px;
  height: 20px;
  padding: 0px;
  margin: 0px;
  position: absolute;
  top: 12px;
  right: 12px;
`;

const ResetButtonContainer = styled.div`
  position: absolute;
  padding: 0px;
  margin: 0px
  width: 34px;
  height: 16px;
  bottom: 16px;
  right: 16px;
`;

const ResetButton = styled.button`
  color: #f94d4d;
  width: 34px;
  height: 16px;
  padding: 0px;
  font-size: 13px;
  line-height: 16px;
  font-weight: 700;
  border: none;
  background: none;
  cursor: pointer;
`;

// TODO width, height 20px
interface CustomPenIconProps {
    onClick: (e: TouchEvent) => void;
    updateScheduleAliasDialogOpen: boolean;
}

const CustomPenIcon = styled(PenLineIcon)<CustomPenIconProps>`
  width: 16px;
  height: 16px;
  background: transparent;
  border-radius: 3px;
  display: ${(props) =>
          props.updateScheduleAliasDialogOpen && "inline !important"};

  &:hover {
    background: ${(props) => props.theme.palette.primitives.gray100};
  }
`;
